(()=>{
 const reduced=()=>matchMedia('(prefers-reduced-motion: reduce)').matches;
 const money=(cents,currency)=>new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency}).format(cents/100);
 function preservePreview(){
  document.querySelectorAll('.hc-airflex-commerce variant-selects').forEach(picker=>{
   if(picker.hcPreservesPreview||typeof picker.updateURL!=='function')return;
   picker.hcPreservesPreview=true;
   const original=picker.updateURL;
   picker.updateURL=function(...args){
    const before=new URL(location.href),result=original.apply(this,args),after=new URL(location.href);
    for(const key of ['view','pb','preview_theme_id'])if(before.searchParams.has(key))after.searchParams.set(key,before.searchParams.get(key));
    if(after.href!==location.href)history.replaceState(history.state,'',after);
    return result;
   };
  });
 }
 function initCommerce(root){
  if(root.dataset.hcEnhanced)return;
  root.dataset.hcEnhanced='true';
  const picker=root.querySelector('variant-selects');
  if(!picker)return;
  let variants;try{variants=JSON.parse(picker.querySelector('script[type="application/json"]').textContent)}catch{return}
  const currency=document.querySelector('[data-hc-currency]')?.dataset.hcCurrency||'USD';
  const fields=[...picker.querySelectorAll('.product-form__input')];
  const chosen=i=>fields[i]?.querySelector('input:checked')?.value||fields[i]?.querySelector('select')?.value;
  const put=(node,value)=>{if(node&&node.textContent!==value)node.textContent=value};
  const count=value=>Number(value?.match(/(\d+)\s*SET/i)?.[1])||1;
  function sync(){
   const design=chosen(0),color=chosen(1),pack=chosen(2);
   const current=variants.find(v=>v.option1===design&&v.option2===color&&v.option3===pack);
   const single=variants.find(v=>v.option1===design&&v.option2===color&&count(v.option3)===1);
   fields[2]?.querySelectorAll('input[type="radio"]').forEach(input=>{
    const variant=variants.find(v=>v.option1===design&&v.option2===color&&v.option3===input.value);
    const label=picker.querySelector('label[for="'+CSS.escape(input.id)+'"]');
    if(!variant||!label)return;
    let unit=label.querySelector('.hc-unit-price');
    if(!unit){unit=document.createElement('span');unit.className='hc-unit-price';label.append(unit)}
    const sets=count(input.value);
    put(unit,money(variant.price/sets,currency)+' / set of 2');
   });
   if(current){
    const sets=count(pack),name=design.replace(/^⭐\s*/,''),saving=single?single.price*sets-current.price:0;
    const summary=name+' · '+color+' · '+sets+(sets===1?' set':' sets')+' / '+sets*2+' straps · '+money(current.price/sets,currency)+' per set'+(saving>0?' · Save '+money(saving,currency)+' vs. single sets':'');
    put(root.querySelector('[data-hc-selection-summary]'),summary);
   }
   document.querySelectorAll('[data-hc-design-price]').forEach(node=>{
    const variant=variants.find(v=>v.option1.includes(node.dataset.hcDesignPrice+' —')&&v.option2===color&&count(v.option3)===1);
    if(variant)put(node,money(variant.price,currency)+' / set of 2');
   });
  }
  let frame;
  const schedule=()=>{if(frame)return;frame=requestAnimationFrame(()=>{frame=0;sync()})};
  picker.addEventListener('change',schedule);
  const grid=picker.querySelector('.quantity-breaks-container');
  if(grid)new MutationObserver(schedule).observe(grid,{childList:true,subtree:true,characterData:true});
  sync();
  const gallery=root.querySelector('[data-hc-showcase]');
  if(gallery){
   const selectPhoto=button=>{
    if(!button)return;
    const image=gallery.querySelector('[data-hc-showcase-image]');
    image.src=button.dataset.hcShowcasePhoto;image.alt=button.dataset.hcPhotoCaption;
    put(gallery.querySelector('[data-hc-showcase-caption]'),button.dataset.hcPhotoCaption);
    gallery.querySelectorAll('[data-hc-showcase-photo]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
   };
   gallery.querySelectorAll('[data-hc-showcase-photo]').forEach(button=>button.addEventListener('click',()=>selectPhoto(button)));
   let previousColor=chosen(1);
   const syncColor=()=>{
    const color=chosen(1);if(color===previousColor)return;previousColor=color;
    selectPhoto(color==='Black'?gallery.querySelector('[aria-label="Product close-up"]'):gallery.querySelector('[aria-label="Black, Gray and Pink"]'));
    if(color!=='Black')put(gallery.querySelector('[data-hc-showcase-caption]'),'Black, Gray & Pink · Selected: '+color);
   };
   picker.addEventListener('change',syncColor);
   if(previousColor!=='Black'){previousColor='';syncColor()}
  }
 }
 function init(){
  document.querySelectorAll('.hc-airflex-commerce').forEach(initCommerce);
  if(customElements.get('variant-selects'))preservePreview();else customElements.whenDefined('variant-selects').then(preservePreview);
  if(!reduced()&&'IntersectionObserver'in window){
   const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
    if(!entry.isIntersecting)return;
    entry.target.animate([{opacity:.55,transform:'translateY(18px)'},{opacity:1,transform:'translateY(0)'}],{duration:420,easing:'ease-out'});
    observer.unobserve(entry.target);
   }),{threshold:.12});
   document.querySelectorAll('.hc-knee-brand-v3 .vl-section-intro,.hc-knee-brand-v3 .vl-mechanism-grid article,.hc-fit-card,.hc-action-header').forEach(node=>{if(!node.dataset.hcMotion){node.dataset.hcMotion='true';observer.observe(node)}});
  }
 }
 document.addEventListener('click',event=>{
  if(event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
  const link=event.target.closest('a[href^="#hc-"]');
  if(!link||!document.querySelector('.hc-airflex-commerce'))return;
  const hash=link.getAttribute('href');
  const target=hash==='#hc-buy'?document.querySelector('.hc-airflex-commerce .product__info-wrapper'):document.getElementById(hash.slice(1));
  if(!target)return;
  if(link.dataset.hcDesign){
   const picker=document.querySelector('.hc-airflex-commerce variant-selects');
   const input=[...picker?.querySelectorAll('input[type="radio"]')||[]].find(x=>x.value.includes(link.dataset.hcDesign+' —'));
   if(input&&!input.checked)input.click();
  }
  event.preventDefault();target.scrollIntoView({behavior:reduced()?'instant':'smooth',block:'start'});
  if(!target.hasAttribute('tabindex'))target.setAttribute('tabindex','-1');
  target.focus({preventScroll:true});
 },true);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
 document.addEventListener('shopify:section:load',init);
})();

(()=>{
function init(){
 document.querySelectorAll('.hc-proof-guide').forEach(root=>{
  if(root.dataset.hcGuideReady)return;root.dataset.hcGuideReady='true';
  root.querySelectorAll('[data-hc-fit-photo]').forEach(button=>button.addEventListener('click',()=>{
   const image=root.querySelector('[data-hc-proof-image]');image.src=button.dataset.hcFitPhoto;image.alt=button.dataset.hcFitAlt;
   root.querySelector('[data-hc-proof-caption]').textContent=button.dataset.hcFitCaption;
   root.querySelectorAll('[data-hc-fit-photo]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
  }));
 });
 document.querySelectorAll('.hc-airflex-commerce variant-selects').forEach(picker=>{
  if(picker.dataset.hcCompareReady)return;picker.dataset.hcCompareReady='true';
  function sync(){
   const name=picker.querySelector('input[name="Support Technology"]:checked')?.value||'';
   document.querySelectorAll('[data-hc-design-card]').forEach(card=>{
    const selected=name.includes(card.dataset.hcDesignCard+' —');card.dataset.selected=String(selected);
    const state=card.querySelector('[data-hc-design-state]');if(state)state.textContent=selected?'Your selected design':'Explore this design';
    const link=card.querySelector('[data-hc-design]');if(link){if(selected)link.setAttribute('aria-current','true');else link.removeAttribute('aria-current')}
   });
  }
  picker.addEventListener('change',()=>requestAnimationFrame(sync));sync();
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',init);
})();
